export default {
    methods: {
        comprobarButacas(filas) {
            var valido = true;

            for (var a in filas) {
                for (var b in filas[a]) {
                    if (filas[a][b].seleccionado && valido) {
                        if (b > 1 && b < filas[a].length - 1) {
                            if ((filas[a][b - 1].seleccionado == 0 && filas[a][b - 1].ocupado == 0) && filas[a][b - 2].ocupado == 1) {
                                valido = false;
                            }

                            if (filas[a][parseInt(b) + 1]) {
                                if (filas[a][parseInt(b) + 2]) {
                                    if ((filas[a][parseInt(b) + 1].seleccionado == 0 && filas[a][parseInt(b) + 1].ocupado == 0) && filas[a][parseInt(b) + 2].ocupado == 1) {
                                        valido = false;
                                    }
                                }
                            }
                        }

                        if ((b > 1 && b < filas[a].length - 1) && filas[a][(b - 1)].ocupado == 1 && filas[a][(parseInt(b) + 1)].ocupado == 1) {
                            valido = true;
                        }

                        if (b > 2 && b < filas[a].length - 2) {
                            if (!valido) {
                                if (filas[a][(b - 1)].seleccionado == 1 && filas[a][(parseInt(b) + 1)].ocupado == 1) {
                                    valido = true;
                                }
                                if (filas[a][(parseInt(b) + 1)].seleccionado == 1 && filas[a][(parseInt(b) - 1)].ocupado == 1) {
                                    valido = true;
                                }
                            }
                        }

                        if (b == 0) {
                            if (filas[a][(parseInt(b) + 1)].seleccionado == 0 && (filas[a][(parseInt(b) + 2)]?.ocupado == 1 && filas[a][(parseInt(b) + 1)].ocupado == 0)) {
                                valido = false;
                            }
                        }

                        if (b == filas[a].length - 1) {
                            if (filas[a][(parseInt(b) - 1)].seleccionado == 0 && (filas[a][(parseInt(b) - 2)]?.ocupado == 1 && filas[a][(parseInt(b) - 1)].ocupado == 0)) {
                                valido = false;
                            }
                        }

                        if (b > 1 && b < filas[a].length - 1) {
                            if (filas[a][(parseInt(b) - 1)].seleccionado == 0) {
                                if (filas[a][(parseInt(b) - 2)]) {
                                    if (filas[a][(parseInt(b) - 2)].seleccionado == 1) {
                                        valido = false;
                                    }
                                }
                            }
                            if (filas[a][(parseInt(b) + 1)].seleccionado == 0) {
                                if (filas[a][(parseInt(b) + 2)]) {
                                    if (filas[a][(parseInt(b) + 2)].seleccionado == 1) {
                                        valido = false;
                                    }
                                }
                            }
                        }

                        if (b == 1 || b == filas[a].length - 1) {
                            if (b == 1 && filas[a][(parseInt(b) - 1)].ocupado == 0 && filas[a][(parseInt(b) - 1)].seleccionado == 0) {
                                valido = false;
                            }

                            if (b == filas[a].length - 1) {
                                if (filas[a][(parseInt(b) + 1)]) {
                                    if (filas[a][(parseInt(b) + 1)].ocupado == 0 && filas[a][(parseInt(b) + 1)].seleccionado == 0) {
                                        valido = false;
                                    }
                                }
                            }
                        }

                        if (b == filas[a].length - 2) {
                            if (filas[a][parseInt(b) + 1].seleccionado == 0 && filas[a][parseInt(b) + 1].ocupado == 0) {
                                valido = false;
                            }
                        }

                        if (b > 1 && b < filas[a].length - 1) {
                            if (filas[a][parseInt(b) + 1].ocupado == 1 && filas[a][parseInt(b) - 1].ocupado == 1) {
                                valido = true;
                            }
                        }

                        const length = filas[a].length;

                        if (b == 1) {
                            let disponibles = 0;

                            if (filas[a][0].ocupado === false) {
                                disponibles++;
                            }
                            if (filas[a][1]?.ocupado === false) {
                                disponibles++;
                            }

                            if (disponibles === 2 && filas[a][2].ocupado === true) {
                                if (filas[a][2].ocupado === true) {
                                    valido = true;
                                } else {
                                    valido = false; 
                                }
                            }
                        } 
                        
                        if (b == length - 2) {
                            let disponibles = 0;

                            if (filas[a][length - 1].ocupado === false) {
                                disponibles++;
                            }
                            if (filas[a][length - 2]?.ocupado === false) {
                                disponibles++;
                            }

                            if (disponibles === 2 && filas[a][length - 3].ocupado === true) {
                                if (filas[a][length - 3].ocupado === true) {
                                    valido = true;
                                } else {
                                    valido = false; 
                                }
                            }
                        }
                    }
                }
            }
            return valido;
        },
    }
}
